import { createSlice } from '@reduxjs/toolkit';
import { fetchProductPricing } from '../actions/quotation.action';

const initialState = {
  productNames: {},
  suppliers: {
    data: [],
    isLoading: false,
    isNeedReloadData: false,
  },
  materialTypes: {},
  materialDescription: {},
  unit: {},
  groups: {},
  details: {
    data: {},
    isLoading: false,
    isNeedReloadData: false,
  },
};

export const quotationReducer = createSlice({
  name: 'Quotation',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchProductPricing.pending, (state, action) => {
        const { key } = action.meta.arg || {};

        state.productNames = {
          ...state.productNames,
          [key]: {
            data: [],
            isLoading: true,
            isNeedReloadData: false,
          },
        };
        state.suppliers = {
          ...state.suppliers,
          isLoading: true,
          isNeedReloadData: false,
        };
        state.materialTypes = {
          ...state.materialTypes,
          [key]: {
            data: [],
            isLoading: true,
            isNeedReloadData: false,
          },
        };
        state.materialDescription = {
          ...state.materialDescription,
          [key]: {
            data: [],
            isLoading: true,
            isNeedReloadData: false,
          },
        };
        state.unit = {
          ...state.unit,
          [key]: {
            data: [],
            isLoading: true,
            isNeedReloadData: false,
          },
        };
        state.groups = {
          ...state.groups,
          [key]: {
            data: [],
            isLoading: true,
            isNeedReloadData: false,
          },
        };
      })
      .addCase(fetchProductPricing.fulfilled, (state, action) => {
        const { data, key } = action.payload || {};
        const filterInfo = data?.filter_info || {};
        state.productNames = {
          ...state.productNames,
          [key]: {
            data: filterInfo.product_name || [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };

        state.materialTypes = {
          ...state.materialTypes,
          [key]: {
            data: filterInfo.material_type || [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.materialDescription = {
          ...state.materialDescription,
          [key]: {
            data: filterInfo.material_description || [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.unit = {
          ...state.unit,
          [key]: {
            data: filterInfo.unit || [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.details = {
          ...state.details,
          [key]: {
            data: data?.list_products || [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.groups = {
          ...state.groups,
          [key]: {
            data: filterInfo?.groups || [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };

        if (!key) {
          state.suppliers = {
            ...state.suppliers,
            isLoading: false,
            data: filterInfo.supplier || [],
          };
        }
      })
      .addCase(fetchProductPricing.rejected, (state, action) => {
        const { key } = action.meta.arg || {};

        state.productNames = {
          ...state.productNames,
          [key]: {
            data: [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.suppliers = {
          ...state.suppliers,
          isLoading: false,
          isNeedReloadData: false,
        };
        state.materialTypes = {
          ...state.materialTypes,
          [key]: {
            data: [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.materialDescription = {
          ...state.materialDescription,
          [key]: {
            data: [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.unit = {
          ...state.unit,
          [key]: {
            data: [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
        state.groups = {
          ...state.groups,
          [key]: {
            data: [],
            isLoading: false,
            isNeedReloadData: false,
          },
        };
      });
  },
});

export default quotationReducer.reducer;
